import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "house-card"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "builder-logo-price-house-wr" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "price-house" }
const _hoisted_6 = {
  key: 2,
  class: "design-suitable-wr"
}
const _hoisted_7 = { class: "lot-container" }
const _hoisted_8 = { class: "lot-title" }
const _hoisted_9 = {
  key: 3,
  class: "design-suitable-wr"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($setup.props.house)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("img", {
          class: "img-house",
          src: $props.house.mainImages[0]
        }, null, 8, _hoisted_2),
        ($setup.lotsByHouseDesigns && $setup.lotsByHouseDesigns.length > 0)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "overlay",
              onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.onViewDesign()))
            }, [...(_cache[1] || (_cache[1] = [
              _createElementVNode("div", { class: "view-design-btn" }, "View design", -1)
            ]))]))
          : _createCommentVNode("", true),
        ($props.house)
          ? (_openBlock(), _createBlock($setup["HouseFeatures"], {
              key: 1,
              features: $props.house,
              directionLogoCalculator: true,
              iconSize: 'tiny',
              class: _normalizeClass('house-features')
            }, null, 8, ["features"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          ($setup.builder)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                class: "builder-logo",
                src: $setup.builder.logo
              }, null, 8, _hoisted_4))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_5, "From " + _toDisplayString($setup.formatPrice($props.house.basePrice)), 1)
        ]),
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "line-container" }, [
          _createElementVNode("div", { class: "line" })
        ], -1)),
        ($setup.lotsByHouseDesigns && $setup.lotsByHouseDesigns.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "text" }, "This design is suitable for lots:", -1)),
              _createElementVNode("div", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.visibleLots, (lot, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "lots",
                    key: index
                  }, [
                    _createElementVNode("div", _hoisted_8, _toDisplayString(lot.title), 1)
                  ]))
                }), 128)),
                ($setup.remainingLots > 0)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "more-btn",
                      onClick: $setup.showMoreLots
                    }, "+ " + _toDisplayString($setup.remainingLots) + " more", 1))
                  : _createCommentVNode("", true)
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_9, [...(_cache[3] || (_cache[3] = [
              _createElementVNode("div", { class: "text-not" }, "Contact us to find out about future releases that may suit this home design", -1)
            ]))]))
      ]))
    : _createCommentVNode("", true)
}